import React from 'react';
import { Box } from '@mui/material';

import { Typography } from '@occc/ui-design-system';

interface LocationsSummaryItem {
  value: number;
  label: string;
  color: string;
}

const LocationsSummaryItem: React.FunctionComponent<LocationsSummaryItem> = ({
  value,
  label,
  color,
}) => {
  return (
    <Box
      display='flex'
      justifyContent='center'
      flex={1}
      boxSizing='border-box'
      sx={({ palette, spacing }) => ({
        p: spacing(0, 3),
        flexFlow: 'column nowrap',

        '&:not(:last-child)': {
          borderRight: `1px solid ${palette.divider}`,
        },
      })}
    >
      <Typography variant='subtitle1' fontWeight={400} gutterBottom>
        {label}
      </Typography>
      <Typography variant='h4' color={color}>
        {value}
      </Typography>
    </Box>
  );
};

export default LocationsSummaryItem;
